<div class="flex align-items-center">
  <a href="/" title="SoftCo" aria-label="Back home" data-md-component="logo"> <img class="sm-logo"
      src="https://knowledgehub-demo.softco.com/images/softco-logo.webp" alt="logo"> </a>
</div>